<template>
	<div
		:class="[
			'c-dashboard',
			{ 'c-dashboard--collapsed': sidebarState === true },
		]"
	>
		<div class="c-dashboard__sidebar">
			<Sidebar>
				<FolderSidebar></FolderSidebar>
				<BucketSidebar> </BucketSidebar>
			</Sidebar>
		</div>

		<div :class="['c-dashboard__main', { bg: hasBackground }]">
			<ViewFilter></ViewFilter>
			<List></List>
		</div>

		<ModalNote></ModalNote>

		<ModalDelete></ModalDelete>
		<ModalCopy></ModalCopy>
		<ModalSmartCopy></ModalSmartCopy>
		<ModalBookmark></ModalBookmark>
		<SelectionPopup></SelectionPopup>
		<PopupEditor></PopupEditor>
		<!-- <Window v-if="mode !== 'iframe'"></Window> -->
	</div>
</template>

<script>
import List from '@/components/dashboard/list';
import ViewFilter from '@/components/dashboard/view-filter';
import Sidebar from '@/components/ui/sidebar';
import BucketSidebar from '@/components/ui/bucket-sidebar';
import FolderSidebar from '@/components/ui/folder-sidebar';
import ModalNote from '@/components/modals/modal-note';
import ModalDelete from '@/components/modals/modal-delete';
import ModalCopy from '@/components/modals/modal-copy';
import ModalSmartCopy from '@/components/modals/modal-smartcopy';
import ModalBookmark from '@/components/modals/modal-bookmark';
import Window from '@/components/ui/window';
import SelectionPopup from '@/components/ui/selection-popup';
import PopupEditor from '@/components/ui/popup-editor';
import hotkeys from 'hotkeys-js';

export default {
	components: {
		ViewFilter,
		List,
		Sidebar,
		BucketSidebar,
		FolderSidebar,
		ModalNote,
		ModalDelete,
		ModalCopy,
		ModalSmartCopy,
		ModalBookmark,
		//Window,
		SelectionPopup,
		PopupEditor,
	},
	data: function () {
		return {
			options: {},
		};
	},
	computed: {
		mode: function () {
			let mode = this.$store.getters['mode'];
			console.log(mode);
			return mode;
		},
		sidebarState: function () {
			return this.$store.getters['dashboard/sidebar'];
		},
		hasBackground: function () {
			return this.$store.getters['settings/hasBackground'];
		},
		selectedNotes: function () {
			return this.$store.getters['note/selectedNotes'];
		},
	},
	methods: {
		onClear: function () {
			this.$store.commit('note/CLEAR_SELECTION');
		},
		onBulkDelete: function () {
			this.$bvModal.show('modal-delete');
		},
		onCopy: function () {
			if (this.selectedNotes.length > 0) {
				this.$bvModal.show('modal-copy');
			}
		},
		onChange: function (query) {
			console.log(query);
		},
		onSmartCopy: function () {
			this.$bvModal.show('modal-smartcopy');
		},
		onBookmark: function () {
			this.$store.dispatch('event/trackEvent', 'Bookmark UI clicked');
			this.$bvModal.show('modal-bookmark');
		},
		toggleHeaderKeys: function () {
			this.$store.dispatch('ui/toggleAllListHeaderState');
		},
		getSibling: function (el, selector, mode) {
			mode = mode || 'next';
			let sibling = el.nextElementSibling;
			if (mode === 'prev') {
				sibling = el.previousElementSibling;
			}
			while (sibling) {
				if (sibling.matches(selector)) {
					return sibling;
				}
				if (mode === 'next') {
					sibling = sibling.nextElementSibling;
				} else {
					sibling = sibling.previousElementSibling;
				}
			}
		},
		setListFocus: function (dir) {
			dir = dir || 'down';
			let el = document.activeElement;
			let sibling = false;
			if (el.classList.contains('c-reading-item')) {
				if (dir === 'down') {
					sibling = this.getSibling(el, '.c-reading-item');
				} else {
					sibling = this.getSibling(el, '.c-reading-item', 'prev');
				}
				if (sibling) {
					sibling.focus();
				}
			} else {
				if (dir === 'down') {
					if (document.querySelectorAll('.c-reading-item')[0]) {
						document.querySelectorAll('.c-reading-item')[0].focus();
					}
				} else {
					let temp = document.querySelectorAll('.c-reading-item');
					console.log(temp);
					if (temp.length < 1) {
						return;
					} else {
						temp[temp.length - 1].focus();
					}
				}
			}
		},
		openGroup: function () {
			let el = document.activeElement;
			if (el.classList.contains('c-reading-item')) {
				let parent = el.nextElementSibling;
				if (parent && parent.classList.contains('c-reading-header')) {
					let key = parent.dataset.key;
					this.$store.dispatch('ui/toggleListHeaderState', key);
				}
			}
		},
		openNoteDetail: function () {
			let el = document.activeElement;
			if (el.classList.contains('c-reading-item')) {
				let id = el.dataset.id;
				this.$store.dispatch('dashboard/setSelectedNote', id);
			}
		},
		setupHotkeys: function () {
			hotkeys('e', 'selection', this.onCopy);
			//hotkeys('q', 'selection', this.toggleHeaderKeys);
			hotkeys('esc', 'selection', this.onClear);
			hotkeys('c', 'selection', this.onSmartCopy);
			hotkeys('b', 'selection', this.onBookmark);
			hotkeys('*', 'selection', this.hotkeyHandler);
			hotkeys.setScope('selection');
		},
		hotkeyHandler: function (e) {
			e.preventDefault();
			if (this.listView === 'reader') {
				return;
			}
			if (e.key === 'ArrowDown' || e.key === 's') {
				this.setListFocus();
			}
			if (e.key === 'ArrowUp' || e.key === 'w') {
				this.setListFocus('up');
			}
			if (e.code === 'Space') {
				this.openGroup();
			}
			// if (e.key === '1') {
			// 	this.openNoteDetail();
			// }
			if (e.key === 'ArrowRight') {
				// set focus to the right panel
			}
			if (e.key === 'ArrowLeft') {
				// set focus to the left panel
			}
			// if(e.key === 'ArrowRight' && e.ctrlKey === true) {
			// 	this.horizontalScroll('right');
			// }
			// if(e.key === 'ArrowLeft' && e.ctrlKey === true) {
			// 	this.horizontalScroll('left');
			// }
		},
		removeHotkeys: function () {
			hotkeys.deleteScope('selection');
		},
	},
	mounted: function () {
		this.setupHotkeys();
	},
	beforeDestroy: function () {
		this.removeHotkeys();
	},
};
</script>

<style lang="scss">
.c-dashboard {
	position: relative;
	z-index: var(--z-2);
	width: 100%;
	height: 100%;

	&__sidebar {
		position: absolute;
		top: 0;
		left: 0;
		width: var(--sidebar-width);
		height: 100%;
		z-index: var(--z-4);
	}

	&__main {
		position: absolute;
		z-index: var(--z-3);
		top: 0;
		left: var(--sidebar-width);
		width: calc(100% - var(--sidebar-width));
		height: 100%;
		overflow-y: auto;
		@include scrollBars();

		&:after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 50%;
			pointer-events: none;
			background: linear-gradient(
				0deg,
				rgba(255, 255, 255, 0) 0%,
				rgba(255, 255, 255, 0.03) 100%
			);
		}

		&.bg {
			background-color: rgb(6 6 6 / 85%);
		}
	}

	&--collapsed {
		.c-dashboard__sidebar {
			transform: translateX(-100%);
		}
		.c-dashboard__main {
			left: 0;
			width: 100%;
		}
	}

	@include media-breakpoint-down(sm) {
		&__sidebar {
			transform: translateX(-100%);
			background-color: var(--g2);
			box-shadow: 0 0px 5.3px rgba(0, 0, 0, 0.145),
				0 0px 17.9px rgba(0, 0, 0, 0.215), 0 0px 80px rgba(0, 0, 0, 0.36);

			.c-sidebar__cover {
				display: none;
			}
		}
		&__main {
			position: absolute;
			left: 0;
			width: 100%;
		}

		&--collapsed {
			.c-dashboard__sidebar {
				transform: translateX(0);
			}
		}
	}
}
</style>